import React from "react";
import {
  Badge,
  Icon,
  SpaceBetween,
  Spinner,
} from "@amzn/awsui-components-react";
import { NEEDS_OWNER_LABEL } from "./investigationUtils";
import "./NeedsOwnerBadge.scss";

interface NeedsOwnerBadgeProps {
  /** Makes the badge a button (e.g. "Take ownership…" in tables); omit for a plain flag. */
  onClick?: () => void;
  /** The click's action is in flight: shows a spinner and ignores further clicks. */
  loading?: boolean;
  /** Accessible name / hover text of the button form. */
  actionLabel?: string;
}

/**
 * The one way an ownerless case is flagged everywhere (table, drawer, overview):
 * a warning icon plus a red "Needs an owner" badge, so it never reads as a neutral state.
 */
export const NeedsOwnerBadge: React.FC<NeedsOwnerBadgeProps> = ({
  onClick,
  loading = false,
  actionLabel = "Take ownership…",
}) => {
  const badge = (
    <SpaceBetween direction="horizontal" size="xxs" alignItems="center">
      {loading ? <Spinner /> : <Icon name="status-warning" variant="warning" />}
      <Badge color="red">
        {onClick ? (
          <span className="lusca-needs-owner-button__label">
            {NEEDS_OWNER_LABEL}
          </span>
        ) : (
          NEEDS_OWNER_LABEL
        )}
      </Badge>
    </SpaceBetween>
  );
  if (!onClick) return badge;
  return (
    <button
      type="button"
      className="lusca-needs-owner-button"
      onClick={onClick}
      disabled={loading}
      aria-label={actionLabel}
      title={actionLabel}
    >
      {badge}
    </button>
  );
};

export default NeedsOwnerBadge;
